import React from 'react';

import styled from 'styled-components';

import { FEES_PRICING_TYPES, FEES_TYPE_LABELS } from 'constants/careTypes';
import { FeeDataType } from 'types/fees';
import { isNonNegativeNumber } from 'utils/helpers/numbers';

import FeesLevels from './FeesLevels';
import FeesNote from './FeesNote';
import { FEES_FIELDS_LEVELS, FIELD_CATEGORY, LEVEL_FEES_FIELDS } from '../../../ShopData/constants';
import Header from '../../common/header/Header';
import { useCareTypesContext } from '../CareTypesContext';
import FeesItems from '../common/FeesItems';
import { getLevelsAverage } from '../utils';

const Container = styled.div`
  box-sizing: border-box;
  position: relative;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

interface Props {
  fee?: FeeDataType;
}

const FeesPreview = ({ fee }: Props) => {
  const { contract } = useCareTypesContext();
  if (!fee?.pricing_type_id) {
    return null;
  }

  const levelAverage = getLevelsAverage(fee);
  const hasAverageCareCost = isNonNegativeNumber(fee?.average_cost);
  const showAverageCareCost =
    (hasAverageCareCost || isNonNegativeNumber(levelAverage)) &&
    [FEES_PRICING_TYPES.LEVELS, FEES_PRICING_TYPES.A_LA_CARTE, FEES_PRICING_TYPES.POINTS].includes(
      fee?.pricing_type_id
    );
  const isLevelsFeeType = fee?.pricing_type_id == FEES_PRICING_TYPES.LEVELS;

  return (
    <Container data-test-id="cd-community-care-fees">
      <Header title={FEES_TYPE_LABELS[fee.fee_type]} />
      <Content>
        {!isLevelsFeeType && (
          <FeesItems
            history={{
              category: FIELD_CATEGORY.FEES,
              field: LEVEL_FEES_FIELDS.AVERAGE_COST,
              community_contract_id: contract?.id,
              label: FEES_TYPE_LABELS[fee.fee_type],
              fee_type: fee.fee_type,
            }}
            field={LEVEL_FEES_FIELDS.AVERAGE_COST}
            title={fee?.pricing_type || ''}
            amount={showAverageCareCost ? fee.average_cost : undefined}
            subtitle={showAverageCareCost ? 'Average' : ''}
          />
        )}
        {isLevelsFeeType && (
          <FeesItems
            history={{
              category: FIELD_CATEGORY.FEES,
              field: FEES_FIELDS_LEVELS,
              community_contract_id: contract?.id,
              label: FEES_TYPE_LABELS[fee.fee_type],
              fee_type: fee.fee_type,
            }}
            field={FEES_FIELDS_LEVELS}
            title="Levels"
            amount={hasAverageCareCost ? fee.average_cost : levelAverage}
            subtitle={showAverageCareCost ? 'Average' : ''}
          />
        )}
        <FeesNote fee={fee} />
        {isLevelsFeeType && <FeesLevels fee={fee} />}
      </Content>
    </Container>
  );
};

export default FeesPreview;
